import { QuotationTypes } from '@shared/constants/quotation-types.constants';

export function getIncidentQuotationsFromTask(task?: any): any[] {
  return [...(task?.incident?.fmQuotation || [])];
}

export function isAddendumQuotationByType(
  quotation: any,
  addendumOfferTypeId: string
): boolean {
  return (
    quotation?.type?.id === addendumOfferTypeId ||
    quotation?.typeId === addendumOfferTypeId ||
    quotation?.type?.defaultName === QuotationTypes.AddendumOffer
  );
}

export function isAcceptedAddendumStatusReasonValue(
  statusReason?: string | null
): boolean {
  return /^(angenommen|accepted)$/i.test(String(statusReason ?? '').trim());
}

export function getLatestAddendumQuotationFromTask(
  task: any,
  addendumOfferTypeId: string
): any | undefined {
  return getIncidentQuotationsFromTask(task)
    .filter(quotation =>
      isAddendumQuotationByType(quotation, addendumOfferTypeId)
    )
    .sort(
      (a, b) =>
        new Date(b?.changeDate || 0).getTime() -
        new Date(a?.changeDate || 0).getTime()
    )[0];
}

export function getLatestAcceptedAddendumQuotationFromTask(
  task: any,
  addendumOfferTypeId: string
): any | undefined {
  return getIncidentQuotationsFromTask(task)
    .filter(
      quotation =>
        isAddendumQuotationByType(quotation, addendumOfferTypeId) &&
        isAcceptedAddendumStatusReasonValue(
          quotation?.statusReason?.defaultName
        )
    )
    .sort(
      (a, b) =>
        new Date(b?.changeDate || 0).getTime() -
        new Date(a?.changeDate || 0).getTime()
    )[0];
}

export function getLatestAddendumStatusReasonFromTask(
  task: any,
  addendumOfferTypeId: string
): string {
  return (
    getLatestAddendumQuotationFromTask(task, addendumOfferTypeId)?.statusReason
      ?.defaultName || '-'
  );
}

export function getLatestAddendumQuotationLinesFromTask(
  task: any,
  addendumOfferTypeId: string,
  withMetadata = false
): any[] {
  const latestAddendumQuotation = getLatestAddendumQuotationFromTask(
    task,
    addendumOfferTypeId
  );

  const lines = [...(latestAddendumQuotation?.fmQuotationLine || [])].sort(
    (a, b) => (a?.recordNumber || 0) - (b?.recordNumber || 0)
  );

  if (!withMetadata) {
    return lines;
  }

  const statusReasonName =
    latestAddendumQuotation?.statusReason?.defaultName || '';
  return lines.map((line: any) => ({
    ...line,
    serviceProviderCommentAddendum:
      line?.serviceProviderCommentAddendum ||
      line?.serviceProviderComment ||
      '',
    addendumStatusReason: line?.addendumStatusReason || statusReasonName,
  }));
}

export function buildTaskTooltipKey(
  base: string,
  isTask2EvaluateOffersAndCreateSuppliers: boolean, 
  isTask3EvaluateOfferInquiry: boolean,
  isTask7ExecuteOptionalService: boolean,
  isTask11SubmitInvoiceToScanCenter: boolean
): string | null {
  if(isTask2EvaluateOffersAndCreateSuppliers) {
    return `taskmodule.task.offer.tooltip.${base}.evaluate_offer`;
  }
  if (isTask3EvaluateOfferInquiry) {
    return `taskmodule.task.offer.tooltip.${base}.offer_inquiry`;
  }
  if (isTask7ExecuteOptionalService) {
    return `taskmodule.task.offer.tooltip.${base}.execute_optional_service`;
  }
  if (isTask11SubmitInvoiceToScanCenter) {
    return `taskmodule.task.offer.tooltip.${base}.facturation`;
  }
  return null;
}

export function translateIfTooltipKey(
  translate: (key: string) => string,
  key?: string | null
): string | undefined {
  return key ? translate(key) : undefined;
}
